import {
  ADMIN_ID,
  PATIENT_ID,
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
  DIETITIAN_ID,
  PHARMACIST_ID,
} from '../../constants/RoleConstants';
import * as FieldNames from '../../constants/ProfileFields';

const roleFields = {
  [ADMIN_ID]: {
    fields: [
      FieldNames.FIRST_NAME,
      FieldNames.LAST_NAME,
      FieldNames.PHONE,
      FieldNames.D_O_B,
    ],
    requiredFields: [
      FieldNames.LAST_NAME,
      FieldNames.D_O_B,
    ],
  },
  [PATIENT_ID]: {
    fields: [
      FieldNames.FIRST_NAME,
      FieldNames.LAST_NAME,
      FieldNames.PHONE,
      FieldNames.D_O_B,
      FieldNames.SSN,
    ],
    requiredFields: [
      FieldNames.LAST_NAME,
      FieldNames.D_O_B,
      FieldNames.SSN,
    ],
  },
  [DOCTOR_ID]: {
    fields: [
      FieldNames.FIRST_NAME,
      FieldNames.LAST_NAME,
      FieldNames.PHONE,
      FieldNames.D_O_B,
      FieldNames.TITLE_ID,
      FieldNames.SPECIALTY_ID,
      FieldNames.MEDICAL_GROUP_ID,
    ],
    requiredFields: [
      FieldNames.LAST_NAME,
      FieldNames.D_O_B,
      FieldNames.MEDICAL_GROUP_ID,
    ],
  },
  [ASSISTANT_ID]: {
    fields: [
      FieldNames.FIRST_NAME,
      FieldNames.LAST_NAME,
      FieldNames.PHONE,
      FieldNames.D_O_B,
      FieldNames.TITLE_ID,
      FieldNames.SPECIALTY_ID,
      FieldNames.MEDICAL_GROUP_ID,
    ],
    requiredFields: [
      FieldNames.LAST_NAME,
      FieldNames.D_O_B,
      FieldNames.MEDICAL_GROUP_ID,
    ],
  },
  [NURSE_ID]: {
    fields: [
      FieldNames.FIRST_NAME,
      FieldNames.LAST_NAME,
      FieldNames.PHONE,
      FieldNames.D_O_B,
      FieldNames.TITLE_ID,
      FieldNames.SPECIALTY_ID,
      FieldNames.MEDICAL_GROUP_ID,
    ],
    requiredFields: [
      FieldNames.LAST_NAME,
      FieldNames.D_O_B,
      FieldNames.MEDICAL_GROUP_ID,
    ],
  },
  [DIETITIAN_ID]: {
    fields: [
      FieldNames.FIRST_NAME,
      FieldNames.LAST_NAME,
      FieldNames.PHONE,
      FieldNames.D_O_B,
      FieldNames.TITLE_ID,
      FieldNames.SPECIALTY_ID,
      FieldNames.MEDICAL_GROUP_ID,
    ],
    requiredFields: [
      FieldNames.LAST_NAME,
      FieldNames.D_O_B,
      FieldNames.MEDICAL_GROUP_ID,
    ],
  },
  [PHARMACIST_ID]: {
    fields: [
      FieldNames.FIRST_NAME,
      FieldNames.LAST_NAME,
      FieldNames.PHONE,
      FieldNames.D_O_B,
      FieldNames.TITLE_ID,
      FieldNames.SPECIALTY_ID,
      FieldNames.MEDICAL_GROUP_ID,
    ],
    requiredFields: [
      FieldNames.LAST_NAME,
      FieldNames.D_O_B,
      FieldNames.MEDICAL_GROUP_ID,
    ],
  },
};
export default roleFields;



// WEBPACK FOOTER //
// ./src/containers/profile/RoleFieldsMapping.js